module.exports = __webpack_public_path__ + "img/copy.afe18b96.svg";